import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/children';

export default {
    // EMERGENCY CONTACT
    getChildrens(params) {
        return Api()
            .get(RESOURCE_NAME, {params: params})
            .catch((err) => errorHandler(err, null));
    },
    getChildren(id) {
        return Api().get(RESOURCE_NAME + `/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    postChildren(item) {
        const saveChildren = item;
        return Api().post(RESOURCE_NAME, saveChildren)
            .catch((err) => errorHandler(err, null));
    },
    updateChildren(item, id) {
        return Api().put(RESOURCE_NAME + `/${id}`, item)
            .catch((err) => errorHandler(err, null));
    },
    deleteChildren(id) {
        return Api().delete(RESOURCE_NAME + `/${id}`)
            .catch((err) => errorHandler(err, null));
    },
}
